exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/mainProjectDashboard/main-dashboard/main-dashboard.component.css
// module id = ../../../../../src/app/mainProjectDashboard/main-dashboard/main-dashboard.component.css
// module chunks = main